import React, { useState, useCallback, useEffect } from "react";
import { Box } from "@mui/material";
import { ModalCard, getIcon } from "@dishopsaas/design-system";
import getStyles from "../Order.styles";
import ModalBody from "../../ModalBody/ModalBody.view";
import { useAppSelector } from "../../../redux/hook";
import OrderDetailsContent from './OrderDetailsContent'
type Props = {
  open: boolean;
  onClose: () => void;
  order: any;
  showFees: boolean;
  deleteOption: boolean;
  orderType?: string;
  totalPrice?: string;
  isMobile?: boolean;
  isPastOrder?: boolean;
};

export default function OrderDetailModal({
  open,
  onClose,
  order,
  showFees,
  deleteOption,
  orderType,
  totalPrice,
  isMobile,
  isPastOrder,
}: Props) {
  const styles = getStyles()
  const [scrollContainer, setScrollContainer] = useState<HTMLElement | null>(
    null
  );
  const [showScrollButton, setShowScrollButton] = useState(false);
  const { secondaryColor } = useAppSelector(
    (state) => state.configurationReducer
  );

  const setContainerRef = useCallback((node: HTMLElement | null) => {
    if (node) {
      setScrollContainer(node);
    }
  }, []);

  useEffect(() => {
    if (!scrollContainer) return;

    const checkOverflowAndScrollTop = () => {
      const hasOverflow =
        scrollContainer.scrollHeight > scrollContainer.clientHeight;
      const isAtTop = scrollContainer.scrollTop === 0;
      setShowScrollButton(hasOverflow && isAtTop);
    };

    const resizeObserver = new ResizeObserver(checkOverflowAndScrollTop);
    resizeObserver.observe(scrollContainer);
    scrollContainer.addEventListener("scroll", checkOverflowAndScrollTop);

    checkOverflowAndScrollTop();
    const timeout = setTimeout(checkOverflowAndScrollTop, 200);

    return () => {
      clearTimeout(timeout);
      resizeObserver.disconnect();
      scrollContainer.removeEventListener("scroll", checkOverflowAndScrollTop);
    };
  }, [scrollContainer]);

  const handleScrollClick = () => {
    if (scrollContainer) {
      scrollContainer.scrollTo({
        top: scrollContainer.scrollHeight,
        behavior: "smooth",
      });
      setShowScrollButton(false);
    }
  };

  return (
    <ModalCard open={open} maxWidth={398} sxModal={{ p: 0 }} onClose={onClose}>
      <ModalBody
        title={`Commande n°${order?.orderNumber}`}
        onClose={onClose}
        ref={setContainerRef}
        sxBody={{ ...styles.modalBody, position: "relative" }}
      >
        <OrderDetailsContent order={order}
          showFees={showFees}
          deleteOption={deleteOption}
          orderType={orderType}
          totalPrice={totalPrice}
          isMobile={isMobile}
          isPastOrder={isPastOrder} />

        {showScrollButton && (
          <Box onClick={handleScrollClick} sx={styles.scrollButton}>
            {getIcon("ChevronDown", { size: 28, color: secondaryColor })}
          </Box>
        )}
      </ModalBody>
    </ModalCard>
  );
}
